import { render } from "./ImportTicketTemplateDialog.vue?vue&type=template&id=1b2c9605"
import script from "./js/importTicketTemplateDialog.js?vue&type=script&lang=js&external"
export * from "./js/importTicketTemplateDialog.js?vue&type=script&lang=js&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__